import { useMemo } from "react";
import { NavigationLinks, useNavigationLinks } from "./NavigationContext";

export * from "./withDefaultTableNavigationProps";

export function useGetNavigationLink<T extends object, TKey extends keyof NavigationLinks>(
  linkGetter: TKey,
  value?: T,
): string {
  const navigationLinks = useNavigationLinks();
  const navigationLinkGetter = navigationLinks[linkGetter] as any;

  return useMemo(() => {
    if (typeof navigationLinkGetter === "string") {
      return navigationLinkGetter;
    }
    if (value && !Array.isArray(value)) {
      if (navigationLinkGetter) {
        return navigationLinkGetter(value);
      } else {
        console.warn("No link getter for type: ", linkGetter);
      }
    }
    return "";
  }, [ navigationLinkGetter, value, linkGetter ]);
}
